import * as ReactUILayoutEvents from "@skbkontur/react-ui/lib/LayoutEvents";

export interface LayoutEventsSubscription {
    remove(): void;
}

export interface LayoutEventsStatic {
    addListener(callback: () => void): LayoutEventsSubscription;
    emit(): void;
}

export const LayoutEvents = {
    addListener: ReactUILayoutEvents.addListener,
    emit: ReactUILayoutEvents.emit,
};
